<form [formGroup]="editpTicketForm" *ngIf="pTicket" >

    <mat-form-field>
        <mat-label>Ticket type</mat-label>
        <mat-select formControlName="pct_tickettype" [value]="pTicket.pct_tickettype" >
            <mat-option *ngFor="let type of tickettypes" [value]="type.mtt_value">
                {{ type.mtt_value }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Support level</mat-label>
        <mat-select formControlName="pct_supportlevel" [value]="pTicket.pct_supportlevel">
            <mat-option *ngFor="let level of supportlevels" [value]="level.msl_value">
                {{ level.msl_value }}
            </mat-option>
        </mat-select>
    </mat-form-field>


    <mat-form-field>
        <mat-label>Issue type</mat-label>
        <mat-select formControlName="pct_issuetype" [value]="pTicket.pct_issuetype">
            <mat-option *ngFor="let type of issuetypes" [value]="type.mit_value">
                {{ type.mit_value }}
            </mat-option>
        </mat-select>
    </mat-form-field>


    <mat-form-field>
        <mat-label>Severity</mat-label>
        <mat-select formControlName="pct_severity" [value]="pTicket.pct_severity">
            <mat-option *ngFor="let level of severities" [value]="level.msv_value">
                {{ level.msv_value }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Component</mat-label>
        <mat-select formControlName="pct_component" [value]="pTicket.pct_component">
            <mat-option *ngFor="let component of components" [value]="component.mco_value">
                {{ component.mco_value }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select formControlName="pct_status_granulated" [value]="pTicket.pct_status_granulated">
            <mat-option *ngFor="let status of statiGranulated" [value]="status.msg_value">
                {{ status.msg_value }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    
</form>